<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav visible-lg" :class="{ 'ceil': showHead }">
      <!-- 导航logo -->
      <div class="container center_header">
        <div class="header-nav-logo col-xs-6 col-lg-2" @click="changeLogo(headList1)">
          <img v-if="showHead" src="@/assets/img/icon_4.png" alt="">
          <img v-else src="@/assets/img/icon_3.png" alt="">
          <p>Mandarin</p>
        </div>
      <!-- 导航内容right_header -->
      <div class="right_header col-xs-6 col-lg-10">
        <ul class="header-nav-wrapper">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="item.id==indexs?'active':''"
            @click="navClick(item)"
          >
            <router-link :to="item.catalogue">
              {{item.title}}
            </router-link>
          </li>
        </ul>
        <el-popover trigger="click" width="180px" hide-after="0"
							popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 0px;">
							<template #reference>
								<div class="language">
									<div class="language_btn">
										<p class="language_btn_txt">
											{{selectLange}}
										</p>
										<svg v-if="showHead" t="1652253884315" width="11" height="11" viewBox="0 0 1024 1024" version="1.1"
											p-id="5935">
											<path
												d="M957.056 338.624C951.84 327.296 940.512 320 928 320L96 320c-12.512 0-23.84 7.296-29.088 18.624-5.216 11.36-3.328 24.704 4.768 34.208l416 485.344c6.08 7.104 14.944 11.2 24.288 11.2s18.208-4.096 24.288-11.2l416-485.344C960.448 363.328 962.272 349.984 957.056 338.624z"
												p-id="5936" fill="#0084F4"></path>
										</svg>
                    <svg v-else t="1652253884315" width="11" height="11" viewBox="0 0 1024 1024" version="1.1"
											p-id="5935">
											<path
												d="M957.056 338.624C951.84 327.296 940.512 320 928 320L96 320c-12.512 0-23.84 7.296-29.088 18.624-5.216 11.36-3.328 24.704 4.768 34.208l416 485.344c6.08 7.104 14.944 11.2 24.288 11.2s18.208-4.096 24.288-11.2l416-485.344C960.448 363.328 962.272 349.984 957.056 338.624z"
												p-id="5936" fill="#fff"></path>
										</svg>
									</div>
								</div>
							</template>
							
							<div class="header-popover_container">
								<div class="title">{{ $t("language_title") }}</div>
								<div class="languagelist">
									<div v-for="(item, index) in languagelist" :key="index"
										@click='change_language(item.language_id)' style="display:flex; ">
										<span style="margin-left:5px;">{{ item.title }}</span>
									</div>
								</div>
							</div>
				</el-popover>
      </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild hidden-lg" :class="{ 'ceil': showHead }">
      <div class="header-nav-m-logo" @click="changeLogo(headList1)">
        <img v-if="showHead" src="@/assets/img/icon_4.png" alt="">
        <img v-else src="@/assets/img/icon_3.png" alt="">
        Mandarin
        <!-- <img class="center-block logo_img2" src="@/assets/img/logo1.png" alt="logo"> -->
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu">
        <div 
        class="header-nav-m-menu-wrapper"
        data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
        <svg v-if="isShow" width="37.896" style="z-index:9999 ;" height="29.875" viewBox="0 0 37.896 29.875">
          <path id="目录_列表_更多_list" data-name="目录、列表、更多、list" d="M72.614,140.16H48.324a2.722,2.722,0,0,0,0,5.444h24.29a2.722,2.722,0,0,0,0-5.444Zm0,12.141H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444Zm0,12.247H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444ZM40.124,140.2a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,140.2Zm0,12.141a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,152.343Zm0,12.247a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,164.591Z" transform="translate(-37.44 -140.16)" fill="#0084F4"/>
        </svg>
        <svg v-else-if="showHead" style="z-index:9999 ;" width="37.896" height="29.875" viewBox="0 0 37.896 29.875">
          <path id="目录_列表_更多_list" data-name="目录、列表、更多、list" d="M72.614,140.16H48.324a2.722,2.722,0,0,0,0,5.444h24.29a2.722,2.722,0,0,0,0-5.444Zm0,12.141H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444Zm0,12.247H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444ZM40.124,140.2a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,140.2Zm0,12.141a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,152.343Zm0,12.247a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,164.591Z" transform="translate(-37.44 -140.16)" fill="#0084F4"/>
        </svg>
        <svg v-else width="37.896" style="z-index:9999 ;" height="29.875" viewBox="0 0 37.896 29.875">
          <path id="目录_列表_更多_list" data-name="目录、列表、更多、list" d="M72.614,140.16H48.324a2.722,2.722,0,0,0,0,5.444h24.29a2.722,2.722,0,0,0,0-5.444Zm0,12.141H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444Zm0,12.247H48.324a2.722,2.722,0,1,0,0,5.444h24.29a2.722,2.722,0,1,0,0-5.444ZM40.124,140.2a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,140.2Zm0,12.141a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,152.343Zm0,12.247a2.692,2.692,0,0,0-2.684,2.684v.077a2.684,2.684,0,1,0,5.367,0v-.077A2.692,2.692,0,0,0,40.124,164.591Z" transform="translate(-37.44 -140.16)" fill="#fff"/>
        </svg>
       </div>
        <!-- 导航内容 -->
        <div id="menu" class="header-nav-m-wrapper collapse" :class="[isShow ?'header-nav-m-show' :'header-nav-m-show2']">
          <ul  class="header-nav-m-list">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="item.id==indexs?'active':''"
            @click="navClick(item)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.catalogue">
              {{item.title}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
        <div class="header-nav-m-txt">
          <el-popover trigger="click" width="160px" hide-after="0"
							popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 0px;">
							<template #reference>
								<div class="language">
									<div class="language_btn">
										<p class="language_btn_txt">
											{{selectLange}}
										</p>
										<!-- <svg v-if="showHead" t="1652253884315" width="11" height="11" viewBox="0 0 1024 1024" version="1.1"
											p-id="5935">
											<path
												d="M957.056 338.624C951.84 327.296 940.512 320 928 320L96 320c-12.512 0-23.84 7.296-29.088 18.624-5.216 11.36-3.328 24.704 4.768 34.208l416 485.344c6.08 7.104 14.944 11.2 24.288 11.2s18.208-4.096 24.288-11.2l416-485.344C960.448 363.328 962.272 349.984 957.056 338.624z"
												p-id="5936" fill="#515151"></path>
										</svg> -->
                    <svg t="1652253884315" width="11" height="11" viewBox="0 0 1024 1024" version="1.1"
											p-id="5935">
											<path
												d="M957.056 338.624C951.84 327.296 940.512 320 928 320L96 320c-12.512 0-23.84 7.296-29.088 18.624-5.216 11.36-3.328 24.704 4.768 34.208l416 485.344c6.08 7.104 14.944 11.2 24.288 11.2s18.208-4.096 24.288-11.2l416-485.344C960.448 363.328 962.272 349.984 957.056 338.624z"
												p-id="5936" fill="#fff"></path>
										</svg>
									</div>
								</div>
							</template>
							
							<div class="header-popover_container">
								<div class="title">{{ $t("language_title") }}</div>
								<div class="languagelist">
									<div v-for="(item, index) in languagelist" :key="index"
										@click='change_language(item.language_id)' style="display:flex; ">
										<span style="margin-left:5px;">{{ item.title }}</span>
									</div>
								</div>
							</div>
				</el-popover>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getHeaderList} from "../api/api";
import { mapState,mapMutations } from 'vuex'
export default {
  name: "Header",
  props:{
    showHeight:Boolean
  },
  data() {
    return {
      navList:[
      // {
      //     catalogue: "/Mandarin",
      //     id: 1677740311513,
      //     title: "Mandarin"
      //   },
      //   {
      //     catalogue: "PTC",
      //     id: 1677740329702,
      //     title: "PTC"
      //   },
      //   {
      //     catalogue: "/SCTT",
      //     id: 1677740340706,
      //     title: "SCTT"
      //   }

      ],
      showHead:false, // 滚动悬浮header
      selectLange:'', //选择语言
      languagelist:[
      {
          language_id:1,
          title:'English'
        },
        {
          language_id:2,
          title:'简体中文'
        },{
          language_id:3,
          title:'繁體中文'
        }
      ],
      img:'',
      isShow:false, //是否显示下拉
      headList1:{}, //底部跳转
    };
  },
  computed:{
    ...mapState(['indexs','titleName','languageId'])
  },
  methods: {
    ...mapMutations(['changeBack','changeName','upHeaderLanguage']),
    navClick(name) {
      console.log(name,'x');
      this.changeBack(name.id)
      this.changeName(name.title)
      this.isShow  = !this.isShow
      window.scrollTo(0,0)
    },
    changeLogo(item) {
      console.log(item,'xxxxxxxxxxxxxxxx');
        this.changeBack(item.id)
        this.changeName(item.title)
        this.$router.push({name:item.title})
        window.scrollTo(0,0)
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
      this.isShow  = !this.isShow
    },
    getList() {
      if(this.showHeight) {
        this.showHead = this.showHeight
      }
      getHeaderList().then(res => {
          if(res.code == 0) {
              this.navList = res.data.list
              this.headList1= this.navList[0]
              console.log('this.headList1',res);
          }
        })
        },
    //滚动事件
    handleScroll() {
      var scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 80 || this.showHeight) {
        this.showHead = true
      } else {
        this.showHead = false
      }
    },
change_language (language) {
    this.upHeaderLanguage(language);
    let command = language == 1 ? 'en' : language == 2 ? 'zh' : 'zh_tw'
    this.$i18n.locale = command;
    localStorage.setItem('locale',command)
    console.log(localStorage.getItem('locale'),'xxxxx');
    console.log(language,'language');
    this.languagelist.map(item => {
      if(item.language_id == language) {
        this.selectLange = item.title
      }
    })
    location.reload();
  }
  },
  created() {
    sessionStorage.getItem('dataList')? this.changeBack(sessionStorage.getItem('dataList')):{}
    sessionStorage.getItem('dataName')? this.changeName(sessionStorage.getItem('dataName')):{}
    localStorage.getItem('dataLanguageId')? this.upHeaderLanguage(localStorage.getItem('dataLanguageId')):{}
      // 判断语言
      console.log(localStorage.getItem('dataLanguageId'),this.languageId,'xx');
      if(!localStorage.getItem('dataLanguageId')) {
        let default_lag = localStorage.getItem('locale_place') == 'zh' ? '2' : localStorage.getItem('locale_place') == 'en' ? '1' : '3'
        this.languagelist.map(item => {
          if(item.language_id == default_lag) {
            this.selectLange = item.title
          }
        })
        }else {
          this.languagelist.map(item => {
          if(item.language_id == this.languageId) {
            this.selectLange = item.title
          }
        })
    }
    this.getList()
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
        window.addEventListener("scroll", this.handleScroll)
      })
      window.addEventListener("popstate", function(e) {
        _this.navList.forEach((res) => {
          if(res.catalogue == e.target.location.pathname.split('/')[1]) {
            _this.changeBack(res.id)
          }
        })
        console.log(e.target.location.pathname,'xxxxxxx');
  
    });
  }
};
</script>
<style scoped lang='less'>
/* 顶部 */
.header-nav {
    position: fixed;
    z-index: 999;
    width: 100%;
    top: 0px;
    left: 0px;
  -webkit-transition: 0.4s all ease-in;
    transition: 0.4s all ease-in;
}
#header .header-top {
  height: 50px;
  // color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #13816F;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 80px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  color: #FFFFFF;
  font-size: 27px;
  line-height: 80px;
  cursor: pointer;
  width: 160px;
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo {
  img {
    height: 50px;
    margin-right: 5px;
  }
  p {
    margin-bottom: 0;
  }
 }
 #header .header-nav .logo_img {
  cursor:default ;
  img {
    width: 115px;
    height: 35px;
  }
 }
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 40px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #FFFFFF;
  font-size: 14px;
  // font-weight: bold;
  // padding: 10px 0;
  display: inline-block;
  height: 100%;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0084F4;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0084F4;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: rgba(255, 255, 255, .5);
  text-decoration: none;
  // border-bottom: 2px solid #7DCEC1;
}
#header .ceil .header-nav-wrapper > li.active > a {
  color: #0084F4;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 1200px) {
  #header .header-nav-m .header-nav-m-wrapper .header-nav-m-list li a:hover {
    color: #0084F4;
    text-decoration: none;
  }
  #header .header-nav-m {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    z-index: 999;
    width: 100%;
    top: 0px;
    left: 0px;
  -webkit-transition: 0.4s all ease-in;
    transition: 0.4s all ease-in;
    padding: 0 30px;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    font-size: 26px;
    line-height: 80px;
    position: relative;
    color: #fff;
    display: flex;
    align-items: center;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    // width: 95px;
    // height: 45px;
    //  width: 145px;
    // height: 50px;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // margin: auto;
      height: 40px;
      margin-right: 5px;
  }
   #header .header-nav-m .header-nav-m-logo {
    .logo_img1 {
      right: 150px;
    }
    .logo_img2 {
      left: 150px;
      width: 115px;
      height: 35px; 
    }
  }
  /* 导航栏  菜单容器 */
  // #header .header-nav-m .header-nav-m-menu {
   
  // }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 9999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #1D3235;
    border-radius: 0px 0px 0px 0px;
    opacity: 0.95;
    z-index: 999;
    .header-nav-m-list {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -10%;
      li {
        margin: 25px 0;
        text-align: center;
        a {
          color: #fff;
          font-size: 15px;
          font-weight: bold;
          padding: 15px 0;
          position: relative;
          span {
            font-size: 10px;
          }
        }
      }
      }
    .header-nav-m-txt {
      width: 100%;
      position: absolute;
      color: #fff;
      bottom: 100px;
      display: flex;
      justify-content: center;
      .language_btn {
        padding: 8px 20px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 20px;
        border: 1px solid #0084F4;
        width: 100%;
        p {
          margin:0 ;
          margin-right: 5px;
        }
      }
    }
  }
  #header .header-nav-m .header-nav-m-show {
    top: 0;
    // animation: logowrap .8s linear
  }
  #header .header-nav-m .header-nav-m-show2 {
    top: -1000px;
    // animation: logo 1s linear
  }
  @keyframes logowrap {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes logo {
  0% {
    transform: translateY(0);
  }
  100% { 
    transform: translateY(-100%);
  }
}

  #header .header-nav .header-nav-logo {
  width: 120px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo {
  img {
    width: 110px;
    height: 40px;
    margin-left: 0;
  }
 }
  #header .header-nav .logo_img {
  img {
    width: 100px;
    height: 30px;
  }
 }
}
#header .ceil .header-nav-wrapper > li > a {
  color: #000 ;
}
.ceil {
    top: 0;
    // box-shadow: 0px 10px 10px 0px rgba(2, 30, 250, 0.1);
    // border-radius: 10px;
    background-color: #fff;
    .right_header .language .language_btn .language_btn_txt {
      color: #000;
    }
  }
  .center_header {
    // width: 100%;
    padding: 0;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .right_header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    .language {
      padding:0;
      margin-left: 25px;
      .language_btn {
      padding:6px 16px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 20px;
      border: 1px solid #0084F4;
      .language_btn_txt {
        margin: 0;
        margin-right: 5px;
        color: #fff;
      }
    }
	}
  }
  .header-popover_container {
    width: 190px;
    .title {
      font-size: 18px;
      font-weight: 700;
    }
    .languagelist {
    margin-top: 10px;
    div {
      padding: 8px 10px;
      cursor: pointer;
    }
   }
  }
  #header .ceil .header-nav-logo {
    color: #000;
  }
  #header .ceil .header-nav-m-logo {
    color: #0084f4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue